import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i191630530__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 283.46 150.58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".i191630530__cls-1{fill:#fc273f}.i191630530__cls-2{fill:#031f30}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("circle", {
      cx: "241.78",
      cy: "41.69",
      r: "41.69",
      class: "i191630530__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("circle", {
      cx: "141.73",
      cy: "41.69",
      r: "41.69",
      class: "i191630530__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      cx: "41.69",
      cy: "41.69",
      r: "41.69",
      class: "i191630530__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M39.25 120.48c0 7.4-4.68 14.8-15.5 14.8h-9.86V150H6.23v-44.32h17.52c10.82 0 15.5 7.4 15.5 14.8m-16.45 8.16c5.13 0 8.6-3 8.6-8.16s-3.47-8.16-8.6-8.16h-8.91v16.32ZM43.29 150v-32.56h7.21v4.68c2.34-4 6.14-4.68 10.12-4.68h1v6.83h-.69c-6.26 0-10.44 2-10.44 9.68v16ZM63.41 133.63c0-9.55 6.57-16.82 16.69-16.82s16.63 7.27 16.63 16.82-6.57 17-16.63 17-16.69-7.45-16.69-17m25.92 0c0-5.82-3.41-10.43-9.23-10.43s-9.29 4.61-9.29 10.43 3.47 10.56 9.29 10.56 9.23-4.68 9.23-10.56M115.3 150c-6.58 0-11.2-3.35-11.2-10.88v-15.48h-5.63v-6.2h5.63v-9h7.21v9h8.1v6.2h-8.1v14.92c0 2.15 1 5.06 4.49 5.06h4.11V150ZM154.13 135.53h-24.54c.57 5.06 3.6 8.79 9.11 8.79 4.23 0 6.7-2.09 7.46-4.87h7.65c-.88 6.32-6.77 11.13-15.24 11.13-10.12 0-16.51-7.34-16.51-17s6.45-16.82 16.57-16.82c9.43 0 15.62 6.77 15.62 15.68 0 1.25-.06 2.46-.12 3.09M129.91 130h16.82c-1.14-4.94-4-7-8.16-7-4.68.07-7.65 2.92-8.66 7M158 133.63c0-9.55 6.51-16.82 16.75-16.82 8.42 0 14.87 5.12 15.5 12.46h-7.65c-.7-3.54-3.54-6.07-7.91-6.07-5.88 0-9.29 4.61-9.29 10.43s3.41 10.56 9.29 10.56c4.37 0 7.27-2.59 7.91-6.19h7.65c-1.14 7.39-7.08 12.58-15.5 12.58-10.25 0-16.75-7.46-16.75-16.95M209.32 150c-6.58 0-11.19-3.35-11.19-10.88v-15.48h-5.63v-6.2h5.63v-9h7.21v9h8.09v6.2h-8.09v14.92c0 2.15 1 5.06 4.49 5.06h4.11V150ZM216.78 140.84c0-7.34 5.88-10.31 13.85-10.31h8v-1.64c0-3.73-2.78-6.33-6.83-6.33-3.54 0-6.26 1.84-6.89 4.62h-7.34c.76-6.89 6.9-10.37 14.55-10.37 8.28 0 13.59 4.81 13.59 12.9V141c0 1.77.89 2.78 2.6 2.78h.69V150h-3c-3 0-5.88-.76-6.45-4.37-2.72 3.67-6.7 5-10.94 5-6.7-.05-11.83-3.21-11.83-9.79m21.82-3.79v-1.27h-8.73c-2.84 0-5.75 1.33-5.75 4.68s2.66 4.62 5.82 4.62c5.44 0 8.66-3.16 8.66-8.03M251.38 139.32l6.95-.06c.57 3.48 3.42 5.57 7.59 5.57 2.78 0 6.14-1 6.14-4.24 0-2.22-1.58-3.16-5.13-3.8l-5.69-1c-4-.69-9.23-2.34-9.23-8.6 0-5.63 5.12-10.37 13.22-10.37 9.48 0 13.4 6.2 13.47 10.62h-7c-.63-3.09-3.29-4.87-6.77-4.87-3.73 0-5.88 2-5.88 4 0 1.84 1.39 2.59 3.61 3l7.14 1.33c6.14 1.14 9.43 4.11 9.43 9.05 0 7.39-6.64 10.62-13.54 10.62-7.04.01-13.62-3.4-14.31-11.25",
      class: "i191630530__cls-2"
    }, null, -1))
  ]))
}
export default { render: render }